import EmailSelectedDocumentsModal from './EmailSelectedDocumentsModal';

export default EmailSelectedDocumentsModal;
